import { NotifyHelper } from "../../../helpers/toast"
import { ePhongHocTrongKyActionsObj } from "../../action-types/category/IPhongHocTrongKyActions"
import { generateActionForKey, generateActions } from "../generateActions"

export const phongHocTrongKyAction = {
    ...generateActions(ePhongHocTrongKyActionsObj, "PHONG_HOC_TRONG_KY"),
    ...generateActionForKey(ePhongHocTrongKyActionsObj, "PHONG_HOC_TRONG_KY", "ASYNC_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(ePhongHocTrongKyActionsObj, "PHONG_HOC_TRONG_KY", "ASYNC_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(ePhongHocTrongKyActionsObj, "PHONG_HOC_TRONG_KY", "UPDATE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(ePhongHocTrongKyActionsObj, "PHONG_HOC_TRONG_KY", "UPDATE_ERRR", (m) => { NotifyHelper.Error(m) }),
}